import encounterCustomAbilitiesData from '../../../../config/static_data/encounter_custom_abilities.json'
import { ConfiguredCustomAbility } from 'app/frontend/types/custom/RaidPlan'

const encounterCustomAbilities = encounterCustomAbilitiesData as Record<
  string,
  ConfiguredCustomAbility[]
>

export const getEncounterCustomAbilitiesForEncounter = (
  encounterId?: number,
): ConfiguredCustomAbility[] => {
  if (encounterId === undefined) return []
  return encounterCustomAbilities[encounterId.toString()] ?? []
}
